/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOpenItemManual.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/open-item-manual";

export class AutogenModelOpenItemManual<RowType extends ModelRow> extends Endpoint<RowType, RowOpenItemManualFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowOpenItemManual extends ModelRow<RowOpenItemManualFields> {
	constructor(values?: Partial<RowOpenItemManualFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowOpenItemManualFields {
	amount: number;
	amount_c: string;
	amount_d: Date;
	amount_n: number;
	amount_r: number;
	bill_date: Date;
	company_id: string;
	currency_code: string;
	customer_id: string;
	deposit_number: string;
	exchange_rate: number;
	gl_date: Date;
	id: string;
	invoice_no: number;
	invoice_no_string: string;
	name: string;
	order_id: string;
	record_type: string;
	reference_number: string;
	remark: string;
	ship_date: Date;
	source: string;
	source_doc_type_id: string;
	source_id: number;
}

